import cn from 'classnames';
import { useCallback } from 'react';
import { useLivekitRTCState } from '../../provider/VoiceChannel/livekit/useLivekitRTCState';
import { useGatheringChatState } from '../GatheringSessions/gatheringChatState';
import { ActionsDrawer } from './ActionsDrawer';
import { GatheringChatButton } from './Gathering/GatheringChat';
import { GatheringParticipantsButton } from './Gathering/GatheringParticipants/GatheringParticipantsButton';
import { actionsComponent, drawerSize } from './shared/contants';
import {
  ActionsContainer,
  ActionsSession,
  ContainerStyled,
} from './shared/styles';
import { Action } from './shared/types';
import { useActionBarState } from './useActionBarState';

export const GuestActionsBar = () => {
  const { isOpen, setIsOpen, setReopen, openAction, setOpenAction } =
    useActionBarState();

  const { activeSessionId } = useLivekitRTCState();
  const { sessionId } = useGatheringChatState();

  const toggleOpenAction = useCallback(
    (action: Action, fromClose = false) => {
      if (openAction === action) {
        setIsOpen(false);
        // if (action === 'chat' && !fromClose) {
        //   setReopen(action);
        // }
      } else {
        if (isOpen) {
          setReopen(action);
          setIsOpen(false);
          return;
        }
        setOpenAction(action);
      }
    },
    [openAction, isOpen, setOpenAction, setIsOpen, setReopen],
  );

  const Component = actionsComponent[openAction!];

  const onCloseAction = (action: Action) => {
    setReopen(null);
    toggleOpenAction(action, true);
  };

  return (
    <>
      <ActionsDrawer drawerSize={drawerSize[openAction!]}>
        {openAction && Component && (
          <Component onClose={() => onCloseAction(openAction)} isGuest={true} />
        )}
      </ActionsDrawer>

      <ContainerStyled>
        <ActionsContainer>
          <ActionsSession className={cn({ isGuest: true })}>
            <GatheringParticipantsButton
              isGuest={true}
              isOpened={openAction === 'gathering'}
              toggleOpenAction={toggleOpenAction}
            />
          </ActionsSession>
          <GatheringChatButton
            sessionId={activeSessionId!}
            isOpened={
              openAction === 'gatheringChat' && activeSessionId === sessionId
            }
            toggleOpenAction={toggleOpenAction}
            disabled={!activeSessionId}
          />
        </ActionsContainer>
      </ContainerStyled>
    </>
  );
};
